import { render, staticRenderFns } from "./ItemsView.vue?vue&type=template&id=5e8417ab&lang=pug"
import script from "./ItemsView.vue?vue&type=script&lang=js"
export * from "./ItemsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports